export default function getPathnameEndpoint(uri = ''): string {
    return uri.match(/\?/)
        ? uri.substring(uri.lastIndexOf('/'), uri.indexOf('?'))
        : uri.substring(uri.lastIndexOf('/'));
}
